import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

export default class AddProfile extends Component {
  constructor(props) {
    super(props);
    this.saveProfile = this.saveProfile.bind(this);
    this.state = {
      name: this.props.data.name,
      description: this.props.data.description,
      url: this.props.data.url,
      email: this.props.data.email,
      phone: this.props.data.phone
    }
  }
  render() {
    return (
      <Fragment>
    		<div id="new-post">
        <p>If you wish, you can ...</p>
        <h1>Add profile</h1>
    			<form>
    				<div id="profile">
    					<input name="name" value={ this.state.name } onChange={ this.saveProfile }/>
    					<input name="description" value={ this.state.description } onChange={ this.saveProfile }/>
    					<input name="url" value={ this.state.url } onChange={ this.saveProfile }/>
    					<input name="email" value={ this.state.email } onChange={ this.saveProfile }/>
    					<input name="phone" value={ this.state.phone } onChange={ this.saveProfile }/>
    				</div>
    			</form>
    			<Link id="next-step" to="/add/publish">Publish</Link>
    		</div>
    	</Fragment>
    )
  }
  saveProfile(e) {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value },
      () => this.props.onProfileAdd(this.state)
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/new-profile.jsx